import { myIcons } from "@/utils/icons";
import { Select, Tooltip } from "antd";
import { t } from "i18next";

export const ArticleActions = ({ className }: { className: string }) => {
    return (
        <div
            className={className}
            style={{ display: "flex", margin: "10px 0px", justifyContent: "space-between", }}>
            <Tooltip placement="top" title={t("whoAuthorText")}>
                <div style={{ display: 'flex', gap: '10px', padding: '4px 8px', borderRadius: '10px', backgroundColor: 'var(--color-bg-secondary)' }} >
                    <img
                        style={{ width: '25px', borderRadius: '100%' }}
                        src={myIcons.technologies.chatgpt} alt="" />
                    <img
                        style={{ width: '25px', borderRadius: '100%' }}
                        src="../assets/pictures/my-profile3.jpg" alt="" />
                </div>
            </Tooltip>
        </div>
    );
};
